<template>
  <v-card outlined hover :to="{ name: 'faq_detail', params: { slug: item.slug } }" class="faq-card fill-height">
    <v-card-text class="d-flex">
      <v-icon class="mr-3 align-self-start" color="primary">{{ icon }}</v-icon>
      <div>
        <div class="subtitle-1 font-weight-medium text--primary">{{ item.question }}</div>
        <div v-if="showCategory" class="caption grey--text mt-1">{{ category.title }}</div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { faqCategory } from '@/content/faq'

export default {
  name: 'FaqCard',
  props: {
    item: { type: Object, required: true },
    showCategory: { type: Boolean, default: false },
  },
  computed: {
    category() {
      return faqCategory(this.item.category) || { title: '', icon: 'mdi-help-circle-outline' }
    },
    icon() {
      return this.category.icon
    },
  },
}
</script>

<style scoped>
.faq-card {
  text-decoration: none;
}
</style>
